import { TableTitleCell } from '../../Table'

import * as styles from './EmailVariablesReportTableRow.module.css'

function EmailVariablesReportTableRow({ columns, item, showCellBorder }) {
  return (
    <div className={styles.EmailVariablesReportTableRow} key={item.id}>
      {columns.map(column => (
        <TableTitleCell
          avatarProps={{ Icon: false }}
          item={item}
          key={column.name}
          name={column.name}
          showCellBorder={showCellBorder}
          value={item[column.name]}
          width={column.width}
        />
      ))}
    </div>
  )
}

export default EmailVariablesReportTableRow
